import { useEffect } from "react";
import { JOYSPOT_QUIZ_URL } from "@/lib/constants";

export default function JoyspotRedirect() {
  useEffect(() => {
    window.location.replace(JOYSPOT_QUIZ_URL);
  }, []);

  return null;
}
